/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const GlobeIcon = /*#__PURE__*/ createSvgIcon(
  'GlobeIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10 18a7.796 7.796 0 01-3.104-.625 8.064 8.064 0 01-2.552-1.719 8.063 8.063 0 01-1.719-2.552A7.797 7.797 0 012 10c0-1.111.208-2.15.625-3.115a8.064 8.064 0 014.27-4.26A7.797 7.797 0 0110 2c1.111 0 2.15.208 3.115.625a8.095 8.095 0 014.26 4.26C17.792 7.851 18 8.89 18 10a7.797 7.797 0 01-.625 3.104 8.063 8.063 0 01-4.26 4.271A7.774 7.774 0 0110 18zm0-1.563c.236-.236.472-.677.708-1.322.236-.646.417-1.351.542-2.115h-2.5c.125.764.306 1.469.542 2.115.236.645.472 1.086.708 1.322zm-1.896-.208a8.848 8.848 0 01-.51-1.437A15.955 15.955 0 017.229 13H4.25a6.46 6.46 0 001.604 2.031 5.978 5.978 0 002.25 1.198zm3.792 0a5.977 5.977 0 002.25-1.198A6.46 6.46 0 0015.75 13h-2.98c-.096.653-.218 1.25-.364 1.792a8.84 8.84 0 01-.51 1.437zM3.687 11.5h3.355a10.06 10.06 0 01-.052-.781 28.175 28.175 0 010-1.5 8.14 8.14 0 01.052-.719H3.688c-.07.264-.119.517-.146.76a6.508 6.508 0 000 1.48c.027.243.076.496.146.76zm4.876 0h2.874c.028-.278.046-.538.053-.781a25.34 25.34 0 000-1.448c-.007-.25-.025-.507-.053-.771H8.563c-.028.264-.046.52-.053.77a26.254 26.254 0 000 1.46c.007.25.025.506.053.77zm4.395 0h3.354a5.4 5.4 0 00.146-.76 6.504 6.504 0 000-1.49c-.027-.25-.076-.5-.145-.75h-3.355c.028.264.046.524.052.781a27.922 27.922 0 010 1.5 8.112 8.112 0 01-.052.719zM12.771 7h2.979a6.462 6.462 0 00-1.604-2.031 5.978 5.978 0 00-2.25-1.198c.194.417.364.896.51 1.437.146.542.268 1.14.365 1.792zM8.75 7h2.5a11.615 11.615 0 00-.542-2.115C10.472 4.24 10.236 3.8 10 3.563c-.236.236-.472.677-.708 1.322-.236.646-.417 1.351-.542 2.115zm-4.5 0h2.98c.096-.653.218-1.25.364-1.792.146-.541.316-1.02.51-1.437a5.98 5.98 0 00-2.25 1.198A6.462 6.462 0 004.25 7z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default GlobeIcon;
